import React, { useState } from 'react';
import { LeadershipHero } from "../../molecules/LeadershipHero";
import { LeadershipStoryCard } from "../../molecules/LeadershipStoryCard";
import RichText from "../../atoms/RichText";
import './leadership-in-focus.m.css';


const LeadershipInFocusPage = (props) => {
  const { collection = {} } = props.data || {};
  const items = collection.items || [];
  const listingItems = items;
  const summary = collection.summary;

  const ITEMS_PER_PAGE = 5;
  const [visibleItemsCount, setVisibleItemsCount] = useState(ITEMS_PER_PAGE);

  const visibleItems = listingItems.slice(0, visibleItemsCount);
  const hasMore = visibleItemsCount < listingItems.length;

  const handleLoadMore = () => {
    setVisibleItemsCount((prevCount) => prevCount + ITEMS_PER_PAGE);
  };

  const hasStories = listingItems.length > 0;

  return (
    <div styleName="page-wrapper">
      {hasStories && <LeadershipHero collection={collection} />}

      {hasStories ? (
        <div styleName="listing-section">
          <div styleName="listing-container">
            {summary && (
              <div styleName="collection-summary-aligned">
                <RichText content={summary} />
              </div>
            )}
            {visibleItems.map((item, index) => (
              <LeadershipStoryCard key={item.id || index} story={item.story} />
            ))}
            {hasMore && (
              <div styleName="loader-wrapper">
                <button styleName="loader-btn" onClick={handleLoadMore}>
                  Load More
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div styleName="empty-state">
          <p styleName="empty-message">No Stories Found</p>
        </div>
      )}
    </div>
  );
};

export default LeadershipInFocusPage;
